/**
 * 文件下载工具函数
 */

/**
 * 下载文件
 * @param {Blob} blob - 文件blob对象
 * @param {string} fileName - 文件名
 */
export function downloadFile(blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  
  // 触发下载
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

/**
 * 根据响应数据创建下载
 * @param {Blob} responseData - 响应数据
 * @param {string} fileName - 文件名
 * @param {string} mimeType - MIME类型
 */
export function createDownloadFromResponse(responseData, fileName, mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
  const blob = new Blob([responseData], { type: mimeType })
  downloadFile(blob, fileName)
}

/**
 * 下载Excel模板
 * @param {string} templateType - 模板类型
 * @param {string} fileName - 文件名
 */
export function downloadExcelTemplate(templateType, fileName) {
  const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  const blob = new Blob([], { type: mimeType })
  downloadFile(blob, fileName)
}

/**
 * 根据URL下载文件
 * @param {string} url - 文件URL
 * @param {string} fileName - 文件名
 */
export function downloadFromUrl(url, fileName) {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.target = '_blank'
  
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
